<template>
  <div class="banner-section spad">
    <div class="row">
      <div
        class="col-xl-3 offset-xl-0 col-lg-3 offset-lg-0 col-md-3 offset-md-0 col-sm-3 offset-sm-0 col-4 offset-0"
      >
        <div class="ml-3">
          <router-link
            v-if="null != currentCategory"
            :to="{
              name: 'listCategories',
              params: { id: currentCategory.parent_id },
            }"
            ><i class="mdi mdi-arrow-left"></i
          ></router-link>
          <h3>{{ $t("menu.list.categories") }}</h3>
        </div>

        <ul class="mt-3 ml-3">
          <li v-if="null != currentCategory">
            <a
              ><label>{{ currentCategory.name }} </label>
            </a>
            <span class="pull-right"><i class="mdi mdi-check-circle"></i></span>
          </li>
          <li v-for="category in categories" :key="category.id">
            <router-link
              :to="{ name: 'listCategories', params: { id: category.id } }"
              >{{ category.name }}
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-8">
        <div class="row">
          <div
            v-for="category in categories"
            :key="category.id"
            class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 d-flex"
          >
            <div class="card flex-fill mt-4 h-80">
              <div class="card-body ">
                <h5 class="card-title">{{ category.name }}</h5>
                <img
                  class="card-img-top"
                  height="125px"
                  :src="
                    category.picture === 'null'
                      ? storageUrl + 'img_not_found.jpg'
                      : storageUrl + category.picture
                  "
                />
                <ul class="mt-3">
                  <li
                    v-for="category in getChild(category.id)"
                    :key="category.id"
                  >
                    <router-link
                      :to="{
                        name: 'listCategories',
                        params: { id: category.id },
                      }"
                      >{{ category.name }}
                    </router-link>
                  </li>
                </ul>
              </div>
              <div class="card-footer">
                <router-link
                  :to="{ name: 'listCategories', params: { id: category.id } }"
                  class=""
                  >{{ $t("sentence.seeAll") }}</router-link
                >
                <router-link
                  :to="{
                    name: 'ProductsFilters',
                    params: { id: category.id },
                  }"
                  class="pull-right"
                  >{{ $t("menu.list.products") }}</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showError" class="row">
      <div class="col-6 offset-3 alert alert-danger text-center">
        <label>No category found</label>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
export default {
  name: "listCategories",
  props: {
    categories: {
      type: Array,
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.getCategories(this.$route.params.id);
      return;
    }

    this.getCategories();
  },
  data() {
    return {
      storageUrl: config.storageUrl,
      currentCategory: null,
      showError: false,
    };
  },
  methods: {
    getCategories(id = null) {
      let self = this;

      let url = "category";

      if (null !== id) {
        url += "/" + id;
      }

      this.$axios({
        url: url,
        method: "GET",
      })
        .then((response) => {
          self.categories = response.data.parentCategories;
          self.childCategories = response.data.childCategories;

          if (self.categories.length === 0) {
            self.$router.push({
              name: "ProductsFilters",
              params: { id: response.data.currentCategory.id },
            });
          }

          if (null !== response.data.currentCategory) {
            self.currentCategory = response.data.currentCategory;
          }
        })
        .catch(() => {
          self.showError = true;
        });
    },
    getChild(categoryId) {
      return this.childCategories
        .filter((category) => category.parent_id == categoryId)
        .slice(0, 5);
    },
    getCategoryById(categoryId) {
      this.$parent.getCategoryById(categoryId);
    },
    addSubCategoryById(category) {
      this.$parent.addSubCategoryById(category);
    },
    removeCategory(categoryId) {
      this.$parent.removeCategory(categoryId);
    },
  },
};
</script>
